import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { ObservationsAndRecommandationsPluginService } from '../../plugins/observationsandrecommandations/observationsandrecommandations-plugin.service';
import { ActionPlanGroupedItemsModel, ActionPlanModel, ActionPlanItem } from '../../shared/models/index';
import * as _ from 'lodash';
import { ApplicationType } from '../../utils/enums/applicationType.enum';

@Component({
    selector: 'action-plan-detail',
    templateUrl: './detail.component.html',
    standalone: false
})
export class ActionPlanDetailComponent implements OnInit, OnChanges {
  @Input() public actionPlan: ActionPlanModel;
  @Output() public toggleSelectResponsible: EventEmitter<any> = new EventEmitter();
  orderByFieldName = 'order';
  direction = 'asc';
  @Input() query = '';

  public appType = 1;
  public i18nPrefix = 'actionplans.optimisation';
  // Note : we should always use optimisation instead of optimization

  constructor(private service: ObservationsAndRecommandationsPluginService) {}

  ngOnInit() {}

  ngOnChanges() {
    if (
      this.actionPlan &&
      this.actionPlan.hasOwnProperty('applicationType') &&
      this.actionPlan.applicationType === ApplicationType.Maintenance
    ) {
      this.appType = ApplicationType.Maintenance;
      this.i18nPrefix = 'actionplans.maintenance';
    } else {
      this.appType = ApplicationType.Optimization;
      this.i18nPrefix = 'actionplans.optimisation';
    }
  }

  public openResponsible(item: ActionPlanGroupedItemsModel) {
    this.toggleSelectResponsible.emit(item);
  }

  public setOrderBy(newOrderBy: string) {
    this.direction = this.orderByFieldName === newOrderBy ? (this.direction === 'asc' ? 'desc' : 'asc') : 'desc';
    this.orderByFieldName = newOrderBy;
  }
}
